import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getTeamMembers, createTeamMember, updateTeamMember, deleteTeamMember } from '../api/teamMembers';
import { TeamMember } from '../types';

export function useTeamMembers() {
  return useQuery({
    queryKey: ['team-members'],
    queryFn: async () => {
      const result = await getTeamMembers();
      return result.data;
    },
    staleTime: 60000,
  });
}

export function useCreateTeamMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: Partial<TeamMember>) => createTeamMember(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['team-members'] }),
  });
}

export function useUpdateTeamMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: Partial<TeamMember> }) => updateTeamMember(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['team-members'] }),
  });
}

export function useDeleteTeamMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteTeamMember,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['team-members'] }),
  });
}
